<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <div style="min-height:70vh">
      <div class="title">
        <div class="title-line"></div>
        <span>测算结果</span>
      </div>

      <div class="s-xz">
        <p>生肖配对指数（最佳为五星）</p>
      </div>

      <div class="stars">
        <div><span>友情</span><stars :num="starNum" /></div>
        <div><span>爱情</span><stars :num="starNum" /></div>
        <div><span>婚姻</span><stars :num="starNum" /></div>
        <div><span>亲情</span><stars :num="starNum" /></div>
      </div>

      <div class="title">
        <span>详情解析：</span>
      </div>
      <div class="text">
        <p>{{ data.result }}</p>
      </div>
      <div class="text" v-html="data.content">
        <p></p>
      </div>
    </div>
    <font></font>

    <div class="bottom-btn">
      <!-- <div class="ps">温馨提示:本测算仅供参考，切勿过于当真!</div> -->
      <!-- <div class="start-btn" @click="$router.back()">重来一次</div> -->
        <btn></btn>

    </div>
    <div style="height: 1rem"></div>
  </div>
  </div>
</template>

<script>
/**
@description:星座配对结果
@createTime:2021-08-26
@create:wq
*/
import stars from "../../../../components/stars.vue";
import topTab from "@/components/topTab";

import font from "@/components/font";
import btn from "@/components/publicBtn";
export default {
  name: "",
  props: {},
  components: { stars ,topTab ,font,btn},
  data() {
    return {
      starNum: 0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'生肖配对',
        path:'/sxpd'
      },{
        name:'生肖配对',
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    const data = localStorage.getItem("result");
    if (data) {
      this.data = JSON.parse(data);
      this.starNum = parseInt((parseInt(this.data.exponent) / 100) * 5);
    }
  },
  destroyed() {
    localStorage.removeItem("result");
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
}
.res {
  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  margin-bottom: 1rem;
}

.title {
  display: flex;
  align-items: center;
  margin-top: 0.38rem;
  font-weight: bold;
  font-size: 0.3rem;
  font-weight: 400;
  color: #333333;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  white-space: pre-wrap;
  p {
    // text-indent: 2em;
  }
}
.bottom-btn {
  // position: fixed;
  // bottom: 1.2rem;
  // left: 50%;
  // transform: translateX(-50%);
  margin: 0 auto;
  margin-top: 0.5rem;
  .ps {
    font-size: 0.24rem;
    font-weight: 400;
    color: #f9647d;
    text-align: center;
    margin-bottom: 0.18rem;
  }
}
.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
.tips {
  font-size: 0.24rem;
  font-weight: 400;
  color: #f9647d;
  margin: 0.46rem 0 0.28rem;
  span {
    color: #e5af30;
  }
  //   text-decoration: underline;
}

.s-xz {
  font-size: 0.3rem;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin: 0.4rem 0;
  span {
    color: #f9647d;
  }
}
.stars {
  > div {
    display: flex;
    margin-bottom: 0.32rem;
    span {
      font-size: 0.3rem;
      font-weight: bold;
      color: #333333;
      margin-right: 0.32rem;
    }
  }
}
</style>
